import {
  RetailerNetworkCpgManufacturerProgramsFilter,
  useRetailerNetworkCpgManufacturerProgramsQuery,
} from '@occc/graphql';
import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';

export const useRetailerNetworkCpgManufacturerPrograms = (
  filter: RetailerNetworkCpgManufacturerProgramsFilter,
) => {
  return useRetailerNetworkCpgManufacturerProgramsQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables: {
      filter,
    },
  });
};
